module.exports = __webpack_public_path__ + "img/mobile-64.79254679.png";